<template>
  <div class="calico-navbar-view">
    <h2>Navbar Items</h2>
    <div class="navbar">
      <CalicoNavbarMenuItem @click="handleHomeClick">
        <i class="bi bi-house" />
        <span class="body--medium">Home</span>
      </CalicoNavbarMenuItem>

      <CalicoNavbarMenuItem @click="handleFavClick">
        <i class="bi bi-star" />
        <span class="body--medium">Fav</span>
      </CalicoNavbarMenuItem>

      <CalicoNavbarMenuItem @click="handleSettingsClick">
        <i class="bi bi-gear" />
        <span class="body--medium">Settings</span>
      </CalicoNavbarMenuItem>
    </div>
  </div>
</template>

<script>
import CalicoNavbarMenuItem from "@/components/calico/navbarMenuItem/index.vue";

export default {
  name: "CalicoNavbarMenuItemView",
  components: {
    CalicoNavbarMenuItem,
  },
  methods: {
    handleHomeClick() {
      alert("Home clicked");
    },
    handleFavClick() {
      alert("Fav clicked");
    },
    handleSettingsClick() {
      alert("Settings clicked");
    }
  }
};
</script>

<style scoped lang="scss">
.calico-navbar-view {
  padding: $space-medium;

  .navbar {
    @include inline-space($space-medium);
  }
}
</style>
